// desktop js start
   $(document).ready(function () {
    // Show default tab content
    $('.tab_content:first').show();
    // Tab and Accordion functionality
    $('.tab_accordtitle').click(function () {
      var tabId = $(this).data('loop');
      $('.tab_content').hide();
      $('.tab_content[data-loop="' + tabId + '"]').fadeIn('slow');;
      $('.tab_accordtitle').removeClass('tab_active');
      $(this).addClass('tab_active');
    });
     $('.accordion .accord_title').click(function () {
    // Toggle the accordion content
    var accordionContent = $(this).next('.accord_cont');
    accordionContent.slideToggle();

    // Toggle the active class
    $('.accordion .accord_title').not(this).removeClass('accord_active');
    $(this).toggleClass('accord_active');

    // Hide other accordion contents
    $('.accordion .accord_cont').not(accordionContent).slideUp();
  });
  });
  // $(document).ready(function() {
  //  var dtaindex = $('.accod_area').data('index');
  //   $('.accod_area').each(function() {
  //       var dataIndex = $(this).data('index');
  //       var accordionCount = $(this).find('.accordion').length;
  //      //var accordionCount = $('.accordion').length;
  //       $('.accord_count').text('('+accordionCount+')');
  //   });
  // });
// end desktop js


// mobo js start
 //  $(document).ready(function () {
 //       $('.accordion .accord_titlemobo').click(function () {
 //    // Toggle the accordion content
 //    var accordionContent = $(this).next('.accord_contmobo');
 //    accordionContent.slideToggle();

 //    // Toggle the active class
 //    $('.accordion .accord_titlemobo').not(this).removeClass('accord_active');
 //    $(this).toggleClass('accord_active');

 //    // Hide other accordion contents
 //    $('.accordion .accord_contmobo').not(accordionContent).slideUp();
 //  });
 // });  

// end mobo js